function switchFilters(){
  if($(".widget-title").length>0){
      setTimeout(function(){
        $(".widget-title").click(function(e) {
            $(this).parent().toggleClass('filter-active').siblings().removeClass('filter-active');
          });       
      },'5000');
    }
}
$(document).ready(function(){
  $('.cat_filter').click(function() {
      setTimeout(function(){
        if ($(".cat_filter a.btn_filter.js_filter.dn.mgr").hasClass("opened")) {
          $(".cat_sortby.cat_sortby_js.col.tr").css("flex-grow", "1");
        }else{
          $(".cat_sortby.cat_sortby_js.col.tr").css("flex-grow", "unset");
        }
      }, 100)
  });
    $("#nt_select_ppr_0 .swatch__title").click(function(){
    $(this).toggleClass("arrow-rotate");
  });
});
